export const FULL_BUTTON_TOOLTIP = "project.creation.full.button.tooltip";
export const SMALL_BUTTON_TOOLTIP = "project.creation.small.button.tooltip";
export const BUTTON_TEXT = "project.creation.button.text";
export const REDIRECT_BUTTON_TEXT = "project.creation.button.cta.text";
